import Vue from 'vue'
import VueSweetalert2 from 'vue-sweetalert2'

Vue.use(VueSweetalert2)

const msgErrorDefault = 'Ha ocurrido un error'
const msgSuccessDefault = 'Operación completada con éxito!'

const error = (msg?: string) => {
    return Vue.swal({
        icon: 'error',
        title: msg || msgErrorDefault,
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 5000,
        timerProgressBar: true
    })
}

const success = (msg?: string) => {
    return Vue.swal({
        icon: 'success',
        title: msg || msgSuccessDefault,
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 5000,
        timerProgressBar: true
    })
}

const info = (msg: string) => {
    return Vue.swal({
        icon: 'info',
        title: msg,
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 5000,
        timerProgressBar: true
    })
}

const confirm = (message: string, showCancelButton = true, icon: 'question' | 'error' = 'question'): Promise<boolean> => {
    return Vue.swal.fire({
        title: '',
        text: message,
        icon: icon,
        showCancelButton: showCancelButton,
        confirmButtonText: 'Aceptar',
        cancelButtonText: 'Cancelar'
    }).then(confirm => {
        if (confirm.value) {
            return true
        } else {
            return false
        }
    })
}

export {
    error,
    success,
    confirm,
    info
}
